<template>
  <a-dropdown v-if="userInfo.id">
    <div class="pt-3">
      <a-avatar size="large">{{ userInfo.name.substring(0, 1) }}</a-avatar>
      <span class="py-4 pl-2 left-8">{{ userInfo.name }}</span>
    </div>
    <a-menu slot="overlay" @click="handleMenuClick"   >
      <a-menu-item key="userinfo" v-show="store.getters.getConfig.is_header">
        <div class="leading-8"  >
          <a-icon type="user" style="font-size: 18px; line-height: 32px" />
          <span class="pl-2">个人中心</span>
        </div>
      </a-menu-item>
      <a-menu-item key="logout">
        <div class="leading-8">
          <a-icon type="poweroff" style="font-size: 18px; line-height: 32px" />
          <span class="pl-2">退出系统</span>
        </div>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
  <div class="flow-root" v-else>
    <a
      class="float-left h-16 py-4 mr-6 text-base font-medium leading-8 text-center cursor-pointer"
      @click="gotoLogin"
      >登入</a
    >
    <div
      class="float-left h-16 py-4 text-base font-medium leading-8 text-center text-white bg-blue-500 cursor-pointer w-28"
      @click="gotoSign"
    >
      立即注册
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import store from '@/store/index';
export default {
  data() {
      return {
        store: store,
      };
    },
  computed: {
    ...mapState('user', ['userInfo']),
  },
  methods: {
    handleMenuClick({ key }) {
      switch (key) {
        case 'userinfo':
          this.$router.push('/admin/contract');
          return;
        case 'logout':
          this.$confirm({
            title: '温馨提示',
            content: '是否退出系统',
            onOk: async () => {
              await this.$store.dispatch('user/logout');
              this.$router.push('/');
            },
          });
          return;
      }
    },
    gotoLogin() {
      this.$store.commit('user/SET_LOGINSTATE', { state: 'PASSWORD' });
      this.$store.commit('user/SET_LOGINFLAG', true);
    },
    gotoSign() {
      this.$store.commit('user/SET_LOGINSTATE', { state: 'SMS_REGISTRY' });
      this.$store.commit('user/SET_LOGINFLAG', true);
    },
  },
};
</script>
